import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  Button,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import {
  getCategorydrp,
  getsubCategorydrp,
  getwardendrp,
  getBed,
  getFloor,
  getserviceProvider,
  getservicedrp,
  getAmenitydrp,
  getProperty,
  insertRiseTicket,
} from "./Api/RSTicketApi";
import { Error } from "@mui/icons-material";

const FORM_INIT_STATE = {
  PropId: "",
  userType: "",
  mobileNumber: "",
  raisedBy: "",
  ticketFor: "unit",
  ticketForText: "unit",
  categoryId: "",
  subCategoryId: "",
  service: "",
  description: "",
  remark: "",
  // wardenId: "",
  // serviceProvId: "",
  attachments: [],
  BedId: "",
  floorId: "",
  amenityId: "",
};
const RaiseServiceTicket = () => {
  const UserId = localStorage.getItem("UserId");
  const navigate = useNavigate();
  const [form, setForm] = useState(FORM_INIT_STATE);
  const [selectedImage, setselectedImage] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  // const [wardenList, setWardenList] = useState([]);
  // const [serviceProviderList, setServiceProviderList] = useState([]);
  const [amenityList, setAmenityList] = useState([]);
  const [isTicketForDisabled, setTicketForDisabled] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState("");

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    const storedLoginType = localStorage.getItem("loginType");
    const storedMobileNumber = localStorage.getItem("mobileNumber");
    const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
    console.log("stored login dtl", {
      storedUserName,
      storedLoginType,
      storedMobileNumber,
      storedIsLoggedIn,
    });
    if (
      !storedUserName ||
      !storedLoginType ||
      localStorage.getItem("isLoggedIn") !== "true"
    ) {
      navigate("/raise-ticket");
    } else {
      setForm((prevDetails) => ({
        ...prevDetails,
        raisedBy: storedUserName,
        mobileNumber: storedMobileNumber,
        userType: storedLoginType === "user" ? "warden" : "resident",
      }));

      setSelectedRadio(storedLoginType === "user" ? "warden" : "resident");
    }
  }, [navigate]);

  // useEffect(() => {
  //   (async () => {
  //     const response = await getProperty({
  //       Flag: "",
  //       UserId: UserId,
  //     });
  //     const {
  //       data: { Status, Data },
  //     } = response;
  //     if (Status === 0 && Array.isArray(Data)) {
  //       setPropertyList(Data);
  //       setForm((prev) => ({
  //         ...prev,
  //         PropId: Data[0]?.Id || "",
  //       }));
  //     } else {
  //       return toast.error("Error: Property not found");
  //     }
  //   })();
  // }, [UserId]);

  useEffect(() => {
    const fetchProperties = async () => {
      const response = await getProperty({ Flag: "", UserId });
      if (response && response.data) {
        const { Status, Data } = response.data;
        if (Status === 0 && Array.isArray(Data)) {
          setPropertyList(Data);
          setForm((prev) => ({
            ...prev,
            PropId: Data[0]?.Id || "",
          }));
        }
      }
    };
    fetchProperties();
  }, [UserId]);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await getCategorydrp({
        PropId: form.PropId,
        flag: "Cat",
      });
      const {
        data: { Status, Data },
      } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setCategoryList(Data);
        setForm((prev) => ({
          ...prev,
          categoryId: Data[0]?.Id || "", 
        }));
      }
    };

    if (form.PropId) {
      fetchCategories();
    }
  }, [form.PropId]);

  useEffect(() => {
    const fetchSubcategories = async () => {
      if (form.categoryId) {
        const response = await getsubCategorydrp({
          flag: "",
          TktCategoryId: form.categoryId,
        });
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data)) {
          setSubcategoryList(Data);
          setForm((prev) => ({
            ...prev,
            subCategoryId: Data[0]?.Id || "",
          }));
        } else {
          setSubcategoryList([]);
          setForm((prev) => ({
            ...prev,
            subCategoryId: "", 
          }));
        }
      }
    };

    fetchSubcategories();
  }, [form.categoryId]);

  useEffect(() => {
    const fetchServices = async () => {
      if (form.subCategoryId) {
        const response = await getservicedrp({
          TktSubCategoryId: form.subCategoryId,
          Flag: "Tk",
        });
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data)) {
          setServiceList(Data);
          setForm((prev) => ({
            ...prev,
            service: Data[0]?.Id || "", // Set the first service as selected
          }));
        } else {
          setServiceList([]);
          setForm((prev) => ({
            ...prev,
            service: "", // Reset service if no data
          }));
        }
      }
    };
    fetchServices();
  }, [form.subCategoryId]);

  useEffect(() => {
    const fetchAmenities = async () => {
      if (form.ticketFor === "amenity") {
        const response = await getAmenitydrp({
          PropId: form.PropId,
          flag: "Am",
        });
        if (response && response.data) {
          const { Status, Data } = response.data;
          if (Status === 0 && Array.isArray(Data)) {
            setAmenityList(Data);
            setForm((prev) => ({
              ...prev,
              amenityId: Data[0]?.Id || "",
            }));
          } else {
            setAmenityList([]);
            setForm((prev) => ({
              ...prev,
              amenityId: "", // Reset service if no data
            }));
          }
        }
      }
    };
    fetchAmenities();
  }, [form.ticketFor, form.PropId]);

  console.log("unitList",unitList);
  useEffect(() => {
    const fetchBeds = async () => {
      if (form.ticketFor === "unit" && form.PropId) {
        const response = await getBed({ PropId: form.PropId, flag: "Bd" });
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data)) {

          setUnitList(Data);
          setForm((prev) => ({
            ...prev,
            BedId: Data[0]?.Id || "",
          }));
        }
      }
    };

    fetchBeds();
  }, [form.ticketFor, form.PropId]);

  useEffect(() => {
    const fetchFloors = async () => {
      if (form.PropId) {
        const floorResponse = await getFloor({
          PropId: form.PropId,
          Flag: "Fl",
        });
        const {
          data: { Status: floorStatus, Data: floorData },
        } = floorResponse;
        if (floorStatus === 0 && Array.isArray(floorData)) {
          setFloorList(floorData);
          setForm((prev) => ({
            ...prev,
            floorId: floorData[0]?.Id || "",
          }));
        } else {
          setFloorList([]);
        }
      }
    };
    fetchFloors();
  }, [form.PropId]);

  // useEffect(() => {
  //   const fetchWardens = async () => {
  //     if (form.PropId) {
  //       const response = await getwardendrp({
  //         PropId: form.PropId,
  //         Flag: "Wr",
  //       });
  //       if(response && response.data){
  //         const {Status, Data} = response.data;
  //         if (Status === 0 && Array.isArray(Data)) {
  //           setWardenList(Data);
  //           setForm((prev) => ({
  //             ...prev,
  //             wardenId: Data[0]?.Id || "",
  //           }));
  //         }else{
  //           setWardenList([]);
  //           setForm((prev) => ({
  //             ...prev,
  //             wardenId: "",
  //           }));
  //         }
  //       }
  //     }
  //   };
  //   fetchWardens();
  // }, [form.PropId]);

  //   const { name, value } = e.target;

  //   if (name === "categoryId") {
  //     setForm((prev) => ({
  //       ...prev,
  //       [name]: value,
  //       subCategoryId: "", // Reset subCategoryId
  //     }));

  //     // Fetch new subcategories based on the selected category
  //     const response = await getsubCategorydrp({ flag: "", TktCategoryId: value });
  //     const {
  //       data: { Status, Data },
  //     } = response;
  //     if (Status === 0 && Array.isArray(Data)) {
  //       setSubcategoryList(Data);
  //       setForm((prev) => ({
  //         ...prev,
  //         subCategoryId: Data[0]?.Id || "", // Set the first subcategory as selected
  //       }));
  //     } else {
  //       setSubcategoryList([]);
  //       setForm((prev) => ({
  //         ...prev,
  //         subCategoryId: "", // Reset subCategoryId if no data
  //       }));
  //     }
  //   } else {
  //     setForm((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };

  // Fetch dropdowns
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   const fetchProvider = async () => {
  //     const response = await getserviceProvider({
  //       TktSubCategoryId: form.subCategoryId,
  //       PropId: form.PropId,
  //       TktCategoryId: form.categoryId,
  //       TktSubCategoryId: form.subCategoryId,
  //       Flag: "Sp",
  //     });
  //     if (response && response.data) {
  //       const { Status, Data } = response.data;
  //       if (Status === 0 && Array.isArray(Data)) {
  //         setServiceProviderList(Data);
  //         setForm((prev) => ({
  //           ...prev,
  //           serviceProvId: Data[0]?.Id || "",
  //         }));
  //       }
  //     }
  //   };

  //   fetchProvider();
  // }, [form.subCategoryId, form.categoryId, form.PropId]);

  const handleBodyChange = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const handleDrop = (acceptedFiles) => {
    setForm((prevDetails) => ({
      ...prevDetails,
      attachments: [...prevDetails.attachments, ...acceptedFiles],
    }));
  };

  const removeAttachment = (index) => {
    setForm((prevDetails) => ({
      ...prevDetails,
      attachments: prevDetails.attachments.filter((_, i) => i !== index),
    }));
  };

  const handleTicketForChange = (e) => {
    const selectedTicket = e.target.value;
    setForm({
      ...form,
      ticketFor: selectedTicket,
      ticketForText: selectedTicket,
    });
    setTicketForDisabled(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      UserId: UserId,
      PropId: form.PropId,
      ResidentId: 4,
      MobileNo: form.mobileNumber,
      Name: form.raisedBy,
      TktFor:
        form.ticketFor === "unit"
          ? "U"
          : form.ticketFor === "property"
          ? "P"
          : "A",
      BedId: form.BedId || 1,
      FloorId: form.floorId || 1,
      AmenityId: form.amenityId || 1,
      TktCategoryId: form.categoryId,
      TktSubCategoryId: form.subCategoryId,
      TicketTypeId: 2,
      TicketTagId: 2,
      TicketSeverityId: 2,
      WardenId:1,
      TktServiceId: form.service,
      ServiceProvId:1,
      EscalateId: 2,
      ForwardedId: 2,
      TktImage: selectedImage || "",
      TicketSt: "O",
      ReqFlg: "R",
      Reason: "Man",
      AcceptFlg: "Y",
      AssignFlg: "Y",
      Description: form.description,
      Remark: form.remark,
      status: "1",
      CreatedBy: 1,
    };

    try {
      const response = await insertRiseTicket(payload);
      console.log("API Response:", response); // More detailed log

      if (response && response.data && response.data.Status === 0) {
        toast.success("Ticket raised successfully!");
        setTimeout(() => {
          navigate("/tkt-dashboard");
        }, 3000);
      } else {
        console.log("Response data indicates failure:", response.data); // Debug info
        toast.error("Failed to raise the ticket.");
      }
    } catch (error) {
      console.error("Error while submitting the ticket:", error); // Detailed error log
      toast.error("An error occurred while submitting the ticket.");
    }
  };

  // const handleNavigate = () => {
  //   navigate("/tkt-dashboard");
  // };

  const handleBack = () => {
    navigate("/tkt-dashboard"); // Navigate to the dashboard
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: "image/*,application/pdf,text/plain",
    multiple: true,
  });
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setselectedImage(reader.result);
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        toast.error("Error reading file. Please try again.");
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <ToastContainer />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{
          maxHeight: "100vh",
          backgroundColor: "#f5f5f5",
          paddingTop: "65px",
        }}
      >
        <Grid item xs={12} md={10} lg={10}>
          <Paper
            elevation={3}
            style={{ padding: "16px", borderRadius: "10px" }}
          >
            <Typography variant="h6" align="center" gutterBottom>
              Raise Service Ticket
            </Typography>
            <form onSubmit={handleSubmit}>
              {/* User Type Radio Buttons */}
              <Box mb={2}>
                <RadioGroup
                  row
                  name="userType"
                  value={form.userType}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="warden"
                    control={<Radio />}
                    label="Warden"
                    disabled
                  />
                  <FormControlLabel
                    value="resident"
                    control={<Radio />}
                    label="Resident"
                    disabled
                  />
                  <FormControlLabel
                    value="auto"
                    control={<Radio />}
                    label="Auto"
                  />
                </RadioGroup>
              </Box>

              {/* property dropdown */}
              <Box mb={2} display="flex" gap={2}>
                <FormControl
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                >
                  <InputLabel>Property</InputLabel>
                  <Select
                    value={form.PropId}
                    onChange={handleChange}
                    name="PropId"
                    label="Property"
                  >
                    {propertyList.length > 0 ? (
                      propertyList.map((property) => (
                        <MenuItem key={property.Id} value={property.PropId}>
                          {property.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No Property available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>

              {/* Mobile Number and Raised By */}
              <Box mb={2} display="flex" gap={2}>
                <TextField
                  fullWidth
                  className="custom-textfield"
                  variant="filled"
                  label="Mobile Number"
                  name="mobileNumber"
                  value={form.mobileNumber}
                  onChange={handleChange}
                  disabled={form.userType !== "auto"}
                />
                <TextField
                  fullWidth
                  className="custom-textfield"
                  variant="filled"
                  label="Raised By"
                  name="raisedBy"
                  value={form.raisedBy}
                  disabled={form.userType !== "auto"}
                />
              </Box>

              <Box mb={2} />

              {/* Ticket For */}
              <Box mb={2}>
                <Typography variant="h6">Ticket For</Typography>
                <RadioGroup
                  row
                  name="ticketFor"
                  value={form.ticketFor}
                  onChange={handleTicketForChange}
                >
                  <FormControlLabel
                    value="unit"
                    control={<Radio />}
                    label="Unit"
                  />
                  <FormControlLabel
                    value="property"
                    control={<Radio />}
                    label="Property"
                  />
                  <FormControlLabel
                    value="amenity"
                    control={<Radio />}
                    label="Amenity"
                  />
                </RadioGroup>
              </Box>

              {/* Unit, Property, Amenity Dropdowns */}
              <Box mb={2} display="flex" gap={2}>
                {form.ticketFor === "unit" && (
                  <Box flex={1}>
                    <FormControl
                      fullWidth
                      variant="filled"
                      className="custom-textfield"
                    >
                      <InputLabel>Bed No.</InputLabel>
                      <Select
                        value={form.BedId}
                        onChange={handleChange}
                        name="BedId"
                        label="Unit"
                      >
                        {unitList.length > 0 ? (
                          unitList.map((unit) => (
                            <MenuItem key={unit.Id} value={unit.Id}>
                              {unit.Name}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No Unit available</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                )}

                {form.ticketFor === "property" && (
                  <Box flex={1}>
                    <FormControl
                      fullWidth
                      variant="filled"
                      className="custom-textfield"
                    >
                      <InputLabel>Floors</InputLabel>
                      <Select
                        value={form.floorId}
                        onChange={handleChange}
                        name="floorId"
                        label="Floor"
                      >
                        {floorList.length > 0 ? (
                          floorList.map((floor) => (
                            <MenuItem key={floor.Id} value={floor.Id}>
                              {floor.Name}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No floors available</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                )}

                {form.ticketFor === "amenity" && (
                  <Box flex={1}>
                    <FormControl
                      fullWidth
                      variant="filled"
                      className="custom-textfield"
                    >
                      <InputLabel>Amenity</InputLabel>
                      <Select
                        value={form.amenityId}
                        onChange={handleChange}
                        name="amenityId"
                        label="Amenity"
                      >
                        {amenityList.length > 0 ? (
                          amenityList.map((amenity) => (
                            <MenuItem key={amenity.Id} value={amenity.Id}>
                              {amenity.Name}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No amenities available</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                )}

                {/* Remark field in the same row */}
                <Box flex={1}>
                  <TextField
                    fullWidth
                    variant="filled"
                    className="custom-textfield"
                    label="Remark"
                    name="remark"
                    value={form.remark || ""}
                    onChange={(e) => handleBodyChange("remark", e.target.value)}
                  />
                </Box>
              </Box>

              {/* Category, subCategoryId, Service Dropdowns */}
              <Box mb={2} display="flex" gap={2}>
                <FormControl
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                >
                  <InputLabel>Category</InputLabel>
                  <Select
                    value={form.categoryId}
                    onChange={handleChange}
                    name="categoryId"
                    label="Category"
                  >
                    {categoryList.length > 0 ? (
                      categoryList.map((category) => (
                        <MenuItem key={category.Id} value={category.Id}>
                          {category.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled> No Category available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>
              <Box mb={2} display="flex" gap={2}>
                <FormControl
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                >
                  <InputLabel>Subcategory</InputLabel>
                  <Select
                    value={form.subCategoryId}
                    onChange={handleChange}
                    name="subCategoryId"
                    displayEmpty
                    inputProps={{
                      inputProps: { "aria-label": "Without label" },
                      autoComplete: "on",
                    }}
                  >
                    {subcategoryList.length > 0 ? (
                      subcategoryList.map((subcategory) => (
                        <MenuItem key={subcategory.Id} value={subcategory.Id}>
                          {subcategory.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No Subcategory available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>
              <Box mb={2} display="flex" gap={2}>
                <FormControl
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                >
                  <InputLabel>Service/complaint</InputLabel>
                  <Select
                    value={form.service}
                    onChange={handleChange}
                    name="service"
                    label="Service"
                  >
                    {serviceList.length > 0 ? (
                      serviceList.map((service) => (
                        <MenuItem key={service.Id} value={service.Id}>
                          {service.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No Service available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>

              {/* <Box mb={2} display="flex" gap={2}>
                <FormControl
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                >
                  <InputLabel>Service Provider</InputLabel>
                  <Select
                    value={form.serviceProvId}
                    onChange={handleChange}
                    name="serviceProvId"
                    displayEmpty
                    inputProps={{
                      inputProps: { "aria-label": "Without label" },
                      autoComplete: "on",
                    }}
                  >
                    {serviceProviderList.length > 0 ? (
                      serviceProviderList.map((provider) => (
                        <MenuItem key={provider.Id} value={provider.Id}>
                          {provider.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>
                        No Service provider available
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box> */}

              {/* Warden Dropdown */}
              {/* <Box mb={2} display="flex" gap={2}>
                <FormControl
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                >
                  <InputLabel>Incharge/Warden</InputLabel>
                  <Select
                    value={form.wardenId}
                    onChange={handleChange}
                    name="wardenId"
                    displayEmpty
                    inputProps={{
                      inputProps: { "aria-label": "Without label" },
                      autoComplete: "on",
                    }}
                  >
                    {wardenList.length > 0 ? (
                      wardenList.map((warden) => (
                        <MenuItem key={warden.Id} value={warden.Id}>
                          {warden.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No Warden available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box> */}
              {/* Upload Image */}
              <Grid
                item
                xs={12}
                md={4}
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  border="1px solid #ccc"
                  borderRadius="5px"
                  width={100}
                  height={40}
                  overflow="hidden"
                  position="relative"
                  sx={{ cursor: "pointer" }}
                >
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="Uploaded Screenshot"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Browse
                    </Typography>
                  )}
                  <input
                    id="upload-screenshot"
                    type="file"
                    accept="image/*"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                    }}
                    onChange={handleFileChange}
                  />
                </Box>
                <Typography variant="h7">Upload Image</Typography>
              </Grid>

              {/* Description */}
              <Box mb={2}>
                <Typography variant="h6">Description</Typography>
                <TextField
                  fullWidth
                  className="custom-textfield"
                  variant="filled"
                  name="description"
                  value={form.description || ""}
                  onChange={(e) =>
                    handleBodyChange("description", e.target.value)
                  }
                  multiline
                  rows={2}
                />
              </Box>

              {/* Submit and Cancel Buttons */}
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                paddingTop="10px"
              >
                 <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleBack}
                  sx={{
                    borderColor: "#635bff",
                    color: "#635bff",
                    "&:hover": {
                      borderColor: "#dddbff",
                      color: "#635bff",
                    },
                    padding: "8px 16px",
                    marginRight: "10px",
                    fontSize: "14px",
                  }}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{
                    backgroundColor: "#635bff",
                    "&:hover": {
                      backgroundColor: "#dddbff",
                    },
                    padding: "8px 16px",
                    fontSize: "14px",
                  }}
                >
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleNavigate}
                  sx={{
                    borderColor: "#635bff",
                    color: "#635bff",
                    "&:hover": {
                      borderColor: "#dddbff",
                      color: "#635bff",
                    },
                    padding: "8px 16px",
                    marginLeft: "10px",
                    fontSize: "14px",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default RaiseServiceTicket;
